import { LANG_KEYS } from "../lang/lang.constants";

type HelpCenterLang = "cs" | "en";

const HELP_CENTER_BASE = "https://help.cleverfarm.ag";

const DEFAULT_HELP_CENTER_LANG: HelpCenterLang = "en";

const LOCALE_TO_HELP_CENTER_LANG: Record<string, HelpCenterLang> = {
  [LANG_KEYS.CZ]: "cs",
  [LANG_KEYS.SK]: "cs",
};

const getHelpCenterLang = (langId: string): HelpCenterLang =>
  LOCALE_TO_HELP_CENTER_LANG[langId] ?? DEFAULT_HELP_CENTER_LANG;

const helpCenterUrl = (
  lang: HelpCenterLang,
  path = "",
  anchor?: string,
): string => `${HELP_CENTER_BASE}/${lang}${path}${anchor ? `#${anchor}` : ""}`;

const getVersionHistoryUrl = (langId: string): string =>
  getHelpCenterLang(langId) === "cs"
    ? `${HELP_CENTER_BASE}/cs/collections/1448978-seznam-verzi`
    : `${HELP_CENTER_BASE}/en/collections/1448978-version-history`;

export {
  HELP_CENTER_BASE,
  getHelpCenterLang,
  getVersionHistoryUrl,
  helpCenterUrl,
  type HelpCenterLang,
};
